import React, { Component } from 'react';

class Spinner extends Component {

    render() {
        
        return <img src="loading.gif" alt="loading progress"/>
    }
}

export default Spinner;

